import { render, staticRenderFns } from "./ITDevice.vue?vue&type=template&id=72932980&"
import script from "./ITDevice.vue?vue&type=script&lang=js&"
export * from "./ITDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports